import React from 'react'

import styled from 'styled-components'

import { UnorderedList } from '../Wrappers'

const StyledList = styled(UnorderedList)<{ $columnsCount: number }>`
  padding-top: 12px;
  column-count: ${({ $columnsCount }) => $columnsCount};
  column-gap: 20px;

  li {
    padding-left: 28px;
    position: relative;
    font-size: 12px;
    line-height: 16px;
    break-inside: avoid;

    &:before {
      position: absolute;
      left: 0px;
      content: '\u25B8';
      width: 16px;
      height: 16px;
      text-align: center;
      color: ${({ theme }) => theme.colors.gray[50]};
    }
  }

  li + li {
    margin-top: 12px;
  }
`

export interface BulletedListProps {
  children: NonNullable<React.ReactNode> | React.ReactNode[]
  columnsCount?: number
}

export function BulletedList({ children, columnsCount = 2 }: BulletedListProps) {
  return (
    <StyledList $columnsCount={columnsCount}>
      {React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a typescript error too.
        if (React.isValidElement(child)) {
          return <li>{React.cloneElement(child)}</li>
        }
        return child
      })}
    </StyledList>
  )
}
